// src/stone/icons/FormHeart2X.tsx
import { jsx } from "react/jsx-runtime";
var FormHeart2X = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M24.107 3.196a8.8 8.8 0 0 1 3.786-.863c1.304 0 2.591.295 3.787.863a9.8 9.8 0 0 1 3.17 2.427 11.3 11.3 0 0 1 2.089 3.58c.481 1.332.728 2.755.728 4.19 0 1.434-.247 2.857-.728 4.188a11.3 11.3 0 0 1-2.09 3.58L20.754 37.325a1 1 0 0 1-1.507 0L5.149 21.162c-1.815-2.081-2.816-4.878-2.816-7.77s1.001-5.688 2.816-7.77c1.819-2.084 4.318-3.288 6.957-3.288s5.138 1.204 6.957 3.289L20 6.697l.936-1.074a9.8 9.8 0 0 1 3.17-2.427m9.236 3.741a7.8 7.8 0 0 0-2.522-1.935 6.8 6.8 0 0 0-2.928-.669c-1 0-1.995.226-2.928.67a7.8 7.8 0 0 0-2.521 1.934l-1.69 1.939a1 1 0 0 1-1.508 0l-1.69-1.938c-1.472-1.688-3.436-2.604-5.45-2.604s-3.978.916-5.45 2.604c-1.475 1.691-2.323 4.011-2.323 6.454 0 2.444.848 4.764 2.323 6.455L20 35.145l13.343-15.298a9.3 9.3 0 0 0 1.715-2.945c.401-1.11.609-2.302.609-3.51s-.208-2.4-.609-3.509a9.3 9.3 0 0 0-1.715-2.946" })
  }
);
var FormHeart2X_default = FormHeart2X;

export {
  FormHeart2X,
  FormHeart2X_default
};
